module.exports = __webpack_public_path__ + "static/MineralSwimV2_Testimonial_3-a276238724f7e9597b6c525327b9760b.jpg";